<template>
  <main class="min-h-screen">
    <!-- MODAL -->
    <div
      v-if="isDone"
      style="
        width: 420px;
        padding: 62px 32px 32px;
        box-shadow: 0 8px 52px 0 rgba(0, 0, 0, 0.18);
      "
      class="
        mx-auto
        bg-white
        rounded-lg
        absolute
        top-[144px]
        right-0
        left-0
        z-9
        flex flex-col
        gap-y-[57px]
        items-center
        justify-center
      "
    >
      <svg
        width="283"
        height="196"
        viewBox="0 0 283 196"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M54.164 167.489c10.23-8.977 11.164-23.636 9.297-36.521-.31-2.147-.324-4.449-1.561-6.229-1.238-1.78-3.772-2.81-5.604-1.688-1.518.928-2.012 2.873-2.737 4.512a12.728 12.728 0 0 1-4.525 5.393c-1.296.866-2.95 1.49-4.39.89-1.973-.822-2.476-3.386-2.698-5.519l-1.248-12.009c-.227-2.147-.46-4.353-1.354-6.287-.894-1.935-2.577-3.695-4.68-4.039-2.103-.343-4.497 1.108-4.7 3.255-.082.895.199 1.785.237 2.68.039.895-.27 1.934-1.088 2.273-.817.338-1.755-.169-2.465-.726-2.452-1.934-4.265-4.551-5.976-7.172-1.712-2.622-3.385-5.32-5.658-7.453-2.272-2.133-5.255-3.71-8.35-3.545-3.094.164-6.16 2.418-6.604 5.528-.445 3.11 1.663 5.987 3.868 8.222a48.139 48.139 0 0 0 11.019 8.406c.73.406 1.523.846 1.866 1.61.624 1.384-.575 2.951-1.934 3.579-1.542.711-3.293.735-4.946 1.118-1.654.382-3.385 1.32-3.868 2.969-.633 2.293 1.45 4.392 3.423 5.698a41.36 41.36 0 0 0 12.92 5.673c1.643.401 3.36.725 4.752 1.697 1.392.973 2.379 2.81 1.774 4.407-.604 1.596-2.523 2.302-4.21 2.176-1.688-.126-3.264-.856-4.908-1.277-3.07-.788-6.856-.164-8.466 2.592-1.054 1.814-.91 4.16-.058 6.09.85 1.929 2.31 3.506 3.839 4.943 5.318 5.025 11.88 8.826 18.982 10.442 7.102 1.615 13.538 1.562 20.04-1.674"
          fill="#EBEBEB"
        />
        <path
          d="M55.382 177.055a94.473 94.473 0 0 0-5.454-17.305 194.736 194.736 0 0 0-9.917-19.868l-2.867-5.074c-.967-1.663-1.88-3.313-2.9-4.87a95.638 95.638 0 0 0-6.35-8.609c-2.15-2.641-4.288-5.069-6.285-7.327a113.908 113.908 0 0 0-5.802-6.118 75.936 75.936 0 0 0-9.278-7.869c-1.165-.842-2.089-1.451-2.722-1.877l-.72-.484a1.874 1.874 0 0 0-.252-.15c.07.069.146.13.227.184l.701.484c.62.435 1.528 1.074 2.674 1.934a81.1 81.1 0 0 1 9.186 7.947c1.814 1.814 3.723 3.869 5.73 6.137 2.007 2.269 4.13 4.697 6.285 7.337a98.658 98.658 0 0 1 6.286 8.59c1.01 1.553 1.934 3.187 2.901 4.837l2.833 5.131a197.345 197.345 0 0 1 9.927 19.83 96.68 96.68 0 0 1 5.545 17.199"
          fill="#E0E0E0"
        />
        <path
          d="M34.132 129.928c.068-.308.104-.622.107-.938.048-.604.087-1.48.12-2.568.068-2.172.058-5.17.04-8.479-.02-3.308 0-6.287.11-8.468.049-1.084.092-1.959.136-2.564a4.272 4.272 0 0 0 0-.967 4.36 4.36 0 0 0-.17.929 40.003 40.003 0 0 0-.26 2.558c-.175 2.167-.252 5.175-.228 8.488.024 3.313.058 6.215.078 8.474v2.568c-.016.324.007.649.067.967zM5.973 127.819c.37.035.742.035 1.112 0 .716 0 1.75-.043 3.027-.038 2.558 0 6.092.111 9.984.406 3.892.295 7.403.735 9.936 1.117 1.267.179 2.287.353 2.993.483a5.51 5.51 0 0 0 1.107.145 6.29 6.29 0 0 0-1.078-.295 55.278 55.278 0 0 0-2.978-.604c-2.53-.45-6.049-.923-9.95-1.228a98.119 98.119 0 0 0-10.014-.295c-1.286.034-2.32.102-3.036.164-.371.016-.74.065-1.103.145zM49.531 159.281c.065-.113.115-.233.15-.358.102-.285.218-.633.363-1.054.31-.909.725-2.244 1.213-3.898.967-3.309 2.2-7.923 3.467-13.03 1.267-5.107 2.442-9.731 3.356-13.059.444-1.62.817-2.945 1.087-3.936.121-.426.213-.784.295-1.074.042-.124.066-.252.073-.382a1.93 1.93 0 0 0-.15.358c-.097.285-.218.633-.363 1.049-.31.914-.725 2.249-1.213 3.903-.967 3.308-2.195 7.922-3.467 13.035-1.271 5.112-2.442 9.726-3.35 13.058-.45 1.62-.818 2.951-1.093 3.937l-.29 1.074a1.39 1.39 0 0 0-.078.377zM11.563 151.504c.121.055.25.092.381.111l1.103.237 4.066.842c3.438.711 8.166 1.746 13.393 2.902 5.227 1.156 9.975 2.142 13.422 2.786 1.726.319 3.123.561 4.09.711l1.117.164c.13.025.264.037.397.034a1.417 1.417 0 0 0-.382-.111l-1.103-.242-4.066-.837c-3.433-.711-8.166-1.746-13.393-2.902-5.226-1.156-9.97-2.142-13.422-2.781a130.827 130.827 0 0 0-4.09-.711l-1.117-.169a1.356 1.356 0 0 0-.396-.034z"
          fill="#E0E0E0"
        />
        <path
          d="m58.887 8.232 29.04 18.432L76.06 46.842l-29.75-19.583L58.888 8.232z"
          fill="#EBEBEB"
        />
        <path
          d="M87.927 26.664a.378.378 0 0 1-.107.029l-.324.063-1.238.227-4.564.774-15.162 2.49h-.107l-.034-.1c-.077-.218-.16-.484-.241-.697-2.026-5.852-3.868-11.124-5.188-14.994-.643-1.905-1.17-3.458-1.543-4.55-.174-.528-.31-.968-.406-1.244-.043-.13-.072-.242-.101-.329a.399.399 0 0 1 0-.11c.018.034.034.07.048.106l.126.314c.106.3.26.71.45 1.228.391 1.089.942 2.631 1.62 4.527 1.348 3.87 3.205 9.137 5.255 14.994l.242.7-.14-.081 15.176-2.419 4.555-.681 1.247-.18.324-.038a.281.281 0 0 1 .112-.03z"
          fill="#E0E0E0"
        />
        <path
          d="M46.312 27.259c0-.068 3.92-1.108 8.8-2.332 4.878-1.223 8.847-2.152 8.862-2.084.014.068-3.921 1.112-8.8 2.331-4.878 1.219-8.848 2.152-8.862 2.085zM76.062 46.842c-.068 0-.735-3.918-1.49-8.774-.754-4.855-1.305-8.802-1.237-8.812.067-.01.735 3.918 1.489 8.774.754 4.856 1.305 8.797 1.238 8.812z"
          fill="#E0E0E0"
        />
        <path
          d="m251.48 63.436 27.806-4.522 3.713 18.814-28.869 4.208-2.65-18.5z"
          fill="#F5F5F5"
        />
        <path
          d="M279.286 58.914c-.06.104-.13.203-.208.295l-.633.812c-.571.745-1.388 1.712-2.355 2.965l-7.924 9.784-.068.083-.092-.049-.532-.295-11.328-6.37-3.423-1.934-.934-.537a2.696 2.696 0 0 1-.314-.208c.117.045.23.098.339.16l.967.483 3.461 1.887 11.368 6.287.527.295-.16.034 7.987-9.74 2.418-2.903c.28-.322.503-.583.667-.783.072-.095.151-.184.237-.266z"
          fill="#E0E0E0"
        />
        <path
          d="M254.13 81.936c-.058-.04 1.779-2.83 4.105-6.23 2.325-3.4 4.25-6.133 4.308-6.089.058.043-1.78 2.825-4.1 6.23-2.321 3.404-4.255 6.127-4.313 6.089zM282.999 77.728c-.043.053-2.596-1.983-5.7-4.546-3.104-2.564-5.56-4.677-5.536-4.735.024-.058 2.596 1.978 5.7 4.541 3.104 2.564 5.58 4.706 5.536 4.74z"
          fill="#E0E0E0"
        />
        <path
          d="m196.708 40.283 47.552-12.749 9.757 32.057-49.453 12.381-7.856-31.689z"
          fill="#455A64"
        />
        <path
          d="M204.565 71.972c-.063-.029 2.557-4.957 5.845-10.998 3.288-6.04 6.005-10.911 6.068-10.882.063.029-2.558 4.957-5.845 11.003-3.288 6.046-6.006 10.911-6.068 10.877zM254.017 59.59c-.039.059-4.835-3.075-10.685-6.998-5.851-3.922-10.579-7.148-10.541-7.206.039-.058 4.835 3.071 10.681 6.998 5.845 3.928 10.584 7.149 10.545 7.207z"
          fill="#263238"
        />
        <path
          d="M196.708 40.283c.054.017.107.038.159.063l.455.213 1.73.837 6.363 3.11 20.936 10.35.256.125-.164.044 12.571-19.477c1.61-2.471 2.901-4.478 3.824-5.876l1.049-1.591.281-.411a.845.845 0 0 1 .101-.136 1.079 1.079 0 0 1-.082.15l-.256.426-1.011 1.615-3.756 5.92-12.518 19.515-.058.097-.102-.053-.256-.126-20.907-10.413-6.324-3.182-1.711-.88-.445-.233a.644.644 0 0 1-.135-.087z"
          fill="#263238"
        />
        <path
          d="m32.67 53.72 46.663 4.666-2.103 31.849L29 84.605l3.67-30.886z"
          fill="#455A64"
        />
        <path
          d="M29 84.605c-.048-.053 3.941-3.56 8.907-7.835 4.965-4.275 9.031-7.7 9.075-7.646.043.053-3.94 3.56-8.911 7.835-4.97 4.275-9.027 7.7-9.07 7.646zM77.244 90.235c-.053.043-3.263-4.353-7.165-9.833s-7.016-9.939-6.963-9.977c.054-.04 3.269 4.352 7.17 9.832 3.903 5.48 7.002 9.94 6.958 9.978z"
          fill="#263238"
        />
        <path
          d="M32.67 53.72s.044.033.121.11l.334.339 1.267 1.33 4.617 4.914 15.172 16.275.184.198h-.164L71.95 63.769l5.391-3.97 1.45-1.06.387-.27a.645.645 0 0 1 .136-.087s-.039.038-.121.106l-.373.29-1.45 1.103c-1.276.967-3.094 2.321-5.319 4.01L54.347 77.07l-.092.068-.078-.083-.183-.198-15.12-16.328-4.559-4.967-1.233-1.364-.314-.358a.97.97 0 0 1-.097-.12z"
          fill="#263238"
        />
        <path
          d="M270.25 101.697s-4.187-2.718-9.186 7.289c-5 10.007-6.871 15.767-6.871 15.767s-1.325 2.099-2.77.745c-1.446-1.354-3.443-5.204-5.87-4.488-2.524.744-3.331 3.574-2.814 7.714.517 4.14 1.315 13.257 1.383 14.084.068.827-.387 2.007-1.518 1.243-1.132-.764-7.669-7.922-10.879-4.619-3.211 3.303.126 14.606.483 15.849.358 1.243.102 1.78-.483 2.09-.585.309-2.558-2.298-4.502-4.261-1.943-1.964-4.535-3.87-6.227-1.829-1.692 2.041-2.171 10.568 6.034 24.309l4.216 6.118 7.446-.484c15.878-1.992 22.285-7.603 22.87-10.205.585-2.602-2.539-3.463-5.28-3.787-2.742-.324-6.01-.266-6.126-.924-.116-.657.159-1.175 1.349-1.673 1.189-.498 12.145-4.836 12.774-9.388.629-4.551-9.037-5.32-10.332-5.736-1.296-.416-.634-1.514.043-1.959.677-.445 8.369-5.436 11.947-7.578 3.578-2.143 5.319-4.518 4.352-6.965-.928-2.355-5.193-1.557-7.151-1.867-1.958-.309-1.117-2.641-1.117-2.641s3.385-5.025 8.22-15.123c4.835-10.099-.039-11.739-.039-11.739"
          fill="#297AFB"
        />
        <path
          d="M265.758 110.65a2.135 2.135 0 0 1-.087.217l-.285.629-1.117 2.394c-.967 2.08-2.417 5.083-4.187 8.783-3.558 7.4-8.568 17.581-14.133 28.812-5.565 11.23-10.598 21.401-14.2 28.782-1.794 3.68-3.244 6.669-4.255 8.744-.483 1.021-.889 1.823-1.16 2.375l-.31.614-.111.208c.025-.074.054-.147.087-.218l.285-.624 1.117-2.418c.967-2.08 2.418-5.078 4.187-8.778 3.559-7.405 8.568-17.586 14.138-28.816s10.593-21.397 14.196-28.777l4.259-8.75 1.161-2.374.304-.615.111-.188z"
          fill="#263238"
        />
        <path
          d="M248.13 126.514c.087.152.153.314.199.483.111.329.256.803.43 1.398.348 1.185.788 2.834 1.238 4.662.449 1.829.826 3.43 1.126 4.687.14.556.257 1.03.348 1.417a1.9 1.9 0 0 1 .107.527 2.283 2.283 0 0 1-.198-.483 28.519 28.519 0 0 1-.426-1.398c-.338-1.19-.754-2.844-1.204-4.672-.45-1.828-.851-3.42-1.16-4.677-.141-.556-.261-1.025-.358-1.412a2.36 2.36 0 0 1-.102-.532zM252.259 139.833c0-.067 3.341-1.122 7.504-2.355 4.163-1.233 7.552-2.181 7.572-2.114.019.068-3.341 1.123-7.504 2.356-4.163 1.233-7.552 2.181-7.572 2.113zM242.933 156.693c.181-.034.366-.045.551-.034h1.489c1.257 0 2.998-.029 4.912-.116 1.915-.087 3.651-.227 4.903-.333l1.489-.126a2.5 2.5 0 0 1 .547 0 2.103 2.103 0 0 1-.537.116c-.348.058-.851.131-1.48.208a67.29 67.29 0 0 1-9.834.45c-.633 0-1.141-.044-1.494-.068a2.595 2.595 0 0 1-.546-.097zM236.55 145.468c.116.124.215.262.295.411.179.271.431.672.73 1.171.61.991 1.451 2.369 2.336 3.903.884 1.533 1.697 2.902 2.267 3.941l.663 1.21c.088.144.159.298.212.459a1.889 1.889 0 0 1-.299-.411 147.677 147.677 0 0 1-3.061-5.074c-.88-1.533-1.702-2.926-2.268-3.941a43.553 43.553 0 0 1-.662-1.21 1.575 1.575 0 0 1-.213-.459zM226.426 159.305c.141.163.266.34.372.527l.967 1.5a398.547 398.547 0 0 1 3.027 4.976 356.2 356.2 0 0 1 2.964 5.021c.348.619.643 1.132.875 1.538.114.184.211.378.29.58a2.96 2.96 0 0 1-.377-.532l-.972-1.494a370.139 370.139 0 0 1-3.032-4.982 380.238 380.238 0 0 1-2.959-5.02l-.875-1.533a3.14 3.14 0 0 1-.28-.581zM234.791 173.05c.236-.045.475-.07.715-.077l1.891-.082c1.595-.068 3.795-.17 6.227-.348 2.432-.179 4.622-.397 6.213-.561l1.881-.194c.228-.04.46-.055.691-.043a4.216 4.216 0 0 1-.677.14c-.444.073-1.083.169-1.876.271a106.973 106.973 0 0 1-12.455.914h-1.895a3.11 3.11 0 0 1-.715-.02z"
          fill="#263238"
        />
        <path
          d="M27.117 167.856c-2.301.315-4.351 1.601-6.029 3.226-.89.876-1.73 1.935-1.886 3.154-.154 1.218.653 2.66 1.896 2.756a3.161 3.161 0 0 0 2.035-.773c1.45-1.05 2.901-2.448 4.7-2.39 1.025.034 2.055.561 3.032.247a2.307 2.307 0 0 0 1.45-2.389 3.956 3.956 0 0 0-1.45-2.549 4.47 4.47 0 0 0-3.748-1.282z"
          fill="#297AFB"
        />
        <path
          opacity=".3"
          d="M27.117 167.856c-2.301.315-4.351 1.601-6.029 3.226-.89.876-1.73 1.935-1.886 3.154-.154 1.218.653 2.66 1.896 2.756a3.161 3.161 0 0 0 2.035-.773c1.45-1.05 2.901-2.448 4.7-2.39 1.025.034 2.055.561 3.032.247a2.307 2.307 0 0 0 1.45-2.389 3.956 3.956 0 0 0-1.45-2.549 4.47 4.47 0 0 0-3.748-1.282z"
          fill="#000"
        />
        <path
          d="M25.754 157.666c0 2.2-2.35 3.119-3.912 2.873-1.561-.247-2.872-1.277-4.105-2.269-2.813-2.273-5.734-4.677-7.155-8.004a5.904 5.904 0 0 1-.552-3.154 3.117 3.117 0 0 1 1.838-2.486c1.204-.44 2.528.112 3.645.736a25.325 25.325 0 0 1 8.316 7.487c1.016 1.45 1.905 3.061 1.934 4.836"
          fill="#297AFB"
        />
        <path
          opacity=".3"
          d="M25.754 157.666c0 2.2-2.35 3.119-3.912 2.873-1.561-.247-2.872-1.277-4.105-2.269-2.813-2.273-5.734-4.677-7.155-8.004a5.904 5.904 0 0 1-.552-3.154 3.117 3.117 0 0 1 1.838-2.486c1.204-.44 2.528.112 3.645.736a25.325 25.325 0 0 1 8.316 7.487c1.016 1.45 1.905 3.061 1.934 4.836"
          fill="#fff"
        />
        <path
          d="M30.076 157.791c-2.054-.541-3.63-2.336-4.303-4.353a11.667 11.667 0 0 1-.048-6.287 19.27 19.27 0 0 1 3.07-6.771 6.887 6.887 0 0 1 2.074-2.056 3.031 3.031 0 0 1 2.82-.188c1.29.662 1.653 2.312 1.812 3.753.28 2.543.359 5.105.237 7.661-.096 2.055-.358 4.198-1.508 5.9-1.15 1.703-2.833 2.781-4.434 2.278"
          fill="#297AFB"
        />
        <path
          d="M41.444 179.885a4.01 4.01 0 0 1-.566-.605l-1.45-1.707a31.499 31.499 0 0 0-2.297-2.394 25.147 25.147 0 0 0-3.196-2.486 14.43 14.43 0 0 0-3.631-1.732 7.387 7.387 0 0 0-3.24-.266 7.114 7.114 0 0 0-2.098.673 3.958 3.958 0 0 1-.735.372c.207-.184.432-.346.672-.484a6.415 6.415 0 0 1 2.127-.793 7.419 7.419 0 0 1 3.36.203c1.322.396 2.578.985 3.728 1.746a23.678 23.678 0 0 1 3.23 2.544c.803.776 1.559 1.6 2.263 2.467.605.74 1.064 1.354 1.383 1.78.174.21.325.439.45.682z"
          fill="#263238"
        />
        <path
          d="M40.331 178.564a1.63 1.63 0 0 1-.237-.3l-.623-.89a117.281 117.281 0 0 0-2.33-3.24c-2.007-2.713-4.918-6.36-8.317-10.224-3.399-3.865-6.658-7.207-9.114-9.519a51.149 51.149 0 0 0-1.668-1.547c-.503-.445-.919-.842-1.276-1.147l-.817-.72c-.1-.079-.191-.168-.271-.266.114.056.22.128.314.213l.856.672c.372.29.812.667 1.32 1.107.507.44 1.088.939 1.707 1.514a123.125 123.125 0 0 1 9.186 9.465c3.385 3.869 6.285 7.555 8.248 10.307a93.056 93.056 0 0 1 2.254 3.313l.57.928c.079.104.145.216.198.334z"
          fill="#263238"
        />
        <path
          d="M35.139 171.208a7.517 7.517 0 0 1-.643-.938 31.037 31.037 0 0 1-1.485-2.718 41.4 41.4 0 0 1-1.755-4.242 39.795 39.795 0 0 1-1.508-5.422 28.297 28.297 0 0 1-.42-10.181c.085-.584.21-1.163.371-1.731.063-.252.112-.484.184-.701l.213-.571c.113-.362.257-.713.43-1.05.087.029-.59 1.519-.967 4.087a29.919 29.919 0 0 0 .513 10.079c.366 1.824.85 3.623 1.45 5.384a43.727 43.727 0 0 0 3.056 7.003c.217.315.405.651.56 1.001zM231.315 65.772H51.168a7.046 7.046 0 0 0-7.045 7.047v114.393a7.046 7.046 0 0 0 7.045 7.047h180.147a7.046 7.046 0 0 0 7.045-7.047V72.819a7.046 7.046 0 0 0-7.045-7.047z"
          fill="#263238"
        />
        <path
          d="M36 184.755h210.439v2.636a8.607 8.607 0 0 1-8.607 8.609H44.616a8.616 8.616 0 0 1-6.086-2.521 8.62 8.62 0 0 1-2.52-6.088v-2.636H36z"
          fill="#263238"
        />
        <path
          d="M232.601 70.874H49.335v108.508h183.266V70.874zM122.092 184.755l2.611 4.155h36.746l2.427-4.155h-41.784z"
          fill="#455A64"
        />
        <path
          d="M227.621 74.55H54.692c-.873 0-1.58.708-1.58 1.582v101.32c0 .874.707 1.582 1.58 1.582h172.929c.873 0 1.581-.708 1.581-1.582V76.132c0-.874-.708-1.582-1.581-1.582z"
          fill="#EBEBEB"
        />
        <path d="M229.202 82.206H53.112v96.827h176.09V82.206z" fill="#FAFAFA" />
        <path
          d="M67.553 78.583a1.407 1.407 0 1 1-2.814 0 1.407 1.407 0 0 1 2.814 0zM59.029 78.583a1.407 1.407 0 1 1-2.814 0 1.407 1.407 0 0 1 2.814 0zM63.12 78.583a1.407 1.407 0 1 1-2.815 0 1.407 1.407 0 0 1 2.815 0zM236.692 184.755c0 .068-43.114.126-96.28.126-53.166 0-96.28-.058-96.28-.126s43.105-.126 96.29-.126c53.185 0 96.27.058 96.27.126z"
          fill="#455A64"
        />
        <path
          d="M81.657 144.651a25.237 25.237 0 0 1 .12-3.526c.036-1.178.159-2.352.368-3.511a25.278 25.278 0 0 1-.12 3.53 24.592 24.592 0 0 1-.368 3.507z"
          fill="#FAFAFA"
        />
        <path
          d="M205.176 135.249c-9.892-15.298-20.162-32.463-20.162-32.463-8.935-10.902-16.153-14.713-30.238-15.303l-27.4-.116c-5.386.305-17.889-2.472-29.493 14.176l-.053-.082s-10.275 17.164-20.162 32.467c-11.087 17.155-4.453 34.968 7.392 36.008 11.977 1.05 19.403 1.369 23.382 1.451l-.188 7.68 63.527-.101-.648-8.604c6.373 0 24.016-.068 26.622-.392 11.802-1.437 18.508-17.547 7.421-34.721zm-95.834-3.386-.397 17.827-11.12.034 11.517-17.861zm62.995 19.138 1.736-16.928 10.941 16.976-12.677-.048z"
          fill="#297AFB"
        />
        <path
          d="M153.713 86.68c.011.134.011.268 0 .402-.004.38-.032.76-.082 1.136-.077.6-.191 1.195-.344 1.78-.215.773-.49 1.528-.822 2.259a13.88 13.88 0 0 1-3.81 4.909 12.427 12.427 0 0 1-7.059 2.723 11.696 11.696 0 0 1-7.31-1.935 12.484 12.484 0 0 1-4.076-4.681 12.753 12.753 0 0 1-1.243-4.01 8.898 8.898 0 0 1-.092-1.141 2.19 2.19 0 0 1 0-.397c.028.13.044.263.049.397 0 .26.063.638.14 1.127a13.257 13.257 0 0 0 1.305 3.941 12.409 12.409 0 0 0 4.047 4.576 11.568 11.568 0 0 0 7.166 1.862 12.267 12.267 0 0 0 6.928-2.656 13.844 13.844 0 0 0 3.791-4.802 13.8 13.8 0 0 0 1.233-3.971c.061-.375.103-.753.126-1.132.007-.13.024-.26.053-.387zM173.875 136.472c-.073 0 .193-7.322.59-16.342.396-9.021.773-16.319.822-16.319.048 0-.194 7.323-.59 16.348-.397 9.025-.755 16.318-.822 16.313zM110.638 103.811c.022.097.031.196.029.295v.837c0 .725.024 1.775 0 3.076 0 2.602-.068 6.191-.252 10.157a237.186 237.186 0 0 1-.686 10.156 108.74 108.74 0 0 1-.411 3.894 1.674 1.674 0 0 1-.049.29 1.213 1.213 0 0 1 0-.295c0-.218.034-.484.054-.832.058-.759.135-1.799.227-3.071.193-2.588.43-6.172.614-10.128.184-3.956.275-7.545.329-10.157 0-1.276.038-2.316.053-3.076 0-.343 0-.619.024-.836.014-.105.037-.209.068-.31zM168.788 169.728a1.869 1.869 0 0 1-.048-.358c0-.256-.058-.604-.102-1.049-.077-.934-.188-2.254-.329-3.908-.266-3.352-.633-8.029-1.059-13.412v-.135h.136l6.247.101 17.705.324 5.367.126 1.451.049h.377a.405.405 0 0 1 .13 0 .405.405 0 0 1-.13 0h-1.828l-5.367-.049-17.715-.208-6.252-.106.121-.131c.392 5.383.73 10.065.967 13.422.107 1.654.198 2.979.256 3.912.03.445.049.794.063 1.05.011.124.015.248.01.372z"
          fill="#263238"
        />
        <path
          d="M196.242 147.823c0 .044-.687 0-1.78.058a18.207 18.207 0 0 0-4.206.74 18.438 18.438 0 0 0-3.907 1.732c-.943.561-1.484.967-1.508.943-.025-.024.116-.126.353-.324.337-.279.693-.536 1.063-.769a15.522 15.522 0 0 1 3.926-1.819 15.857 15.857 0 0 1 4.27-.682c.439-.008.878.008 1.315.049.16.004.319.028.474.072zM112.079 171.523a.264.264 0 0 1 0-.112c0-.087 0-.193.033-.324.039-.304.092-.716.155-1.248.15-1.102.363-2.669.624-4.614.556-3.932 1.32-9.378 2.19-15.539l.121.145-3.385-.049c-7.015-.048-13.373.083-17.976.058-2.301 0-4.163-.033-5.45-.067l-1.479-.049h-.517a.409.409 0 0 1 .13 0h7.316c4.598-.024 10.956-.179 17.981-.13l3.385.048h.126v.14c-.9 6.152-1.698 11.608-2.273 15.526-.295 1.934-.532 3.506-.696 4.604-.087.527-.155.938-.203 1.238 0 .131-.039.237-.058.324-.02.087-.02.049-.024.049z"
          fill="#263238"
        />
        <path
          d="M97.554 149.913a5.644 5.644 0 0 1-.967-.832 31.777 31.777 0 0 1-2.113-2.254c-.783-.919-1.45-1.794-1.886-2.447a5.539 5.539 0 0 1-.662-1.098c.297.307.567.639.807.991.484.624 1.156 1.451 1.934 2.395.779.943 1.509 1.712 2.05 2.287.305.296.585.616.837.958z"
          fill="#263238"
        />
        <path
          d="M125.969 108.59a34.39 34.39 0 0 1-1.992-3.676 35.694 35.694 0 0 1-1.769-3.787 34.39 34.39 0 0 1 1.992 3.676 34.657 34.657 0 0 1 1.769 3.787zM153.166 108.222a6.251 6.251 0 0 1-.967 1.011 28.861 28.861 0 0 1-5.415 3.961 7.024 7.024 0 0 1-1.247.61 8.737 8.737 0 0 1 1.16-.765 49.874 49.874 0 0 0 2.766-1.871 44.503 44.503 0 0 0 2.615-2.07c.343-.316.707-.608 1.088-.876zM166.245 105.857a38.628 38.628 0 0 1-2.766-3.444 38.66 38.66 0 0 1-2.567-3.593 39.57 39.57 0 0 1 2.771 3.444 38.252 38.252 0 0 1 2.562 3.593zM165.346 122.858a22.378 22.378 0 0 1-2.843 1.692 21.755 21.755 0 0 1-2.969 1.474 21.555 21.555 0 0 1 2.848-1.692 21.696 21.696 0 0 1 2.964-1.474zM184.197 124.265a43.042 43.042 0 0 1-.029-4.614c-.008-1.54.066-3.078.223-4.609.092 1.536.102 3.076.029 4.614a41.493 41.493 0 0 1-.223 4.609zM192.015 137.459a49.496 49.496 0 0 1-4.97.425c-2.751.165-4.98.242-4.985.174a49.547 49.547 0 0 1 4.97-.425c2.761-.164 4.98-.242 4.985-.174zM204.669 147.248a43.413 43.413 0 0 1-.436-4.735 43.857 43.857 0 0 1-.178-4.754 46.14 46.14 0 0 1 .43 4.739c.143 1.579.204 3.165.184 4.75zM199.336 159.533a48.447 48.447 0 0 1-3.525 3.54 48.129 48.129 0 0 1-3.694 3.357c-.048-.049 1.528-1.635 3.52-3.541 1.992-1.905 3.651-3.405 3.699-3.356zM178.294 163.475a2.809 2.809 0 0 1-.899-.392 10.232 10.232 0 0 1-3.467-3.178 2.847 2.847 0 0 1-.484-.861 25.47 25.47 0 0 0 2.186 2.467c.843.714 1.733 1.37 2.664 1.964zM123.068 119.593a36.336 36.336 0 0 1-3.186 2.902 37.76 37.76 0 0 1-3.351 2.698 36.492 36.492 0 0 1 3.187-2.902 37.747 37.747 0 0 1 3.35-2.698zM136.452 126.204a8.05 8.05 0 0 1-1.934-4.353c.072 0 .333 1.031.87 2.23.537 1.2 1.126 2.085 1.064 2.123zM112.963 92.77c.044.057-1.755 1.58-4.023 3.385-2.267 1.804-4.134 3.265-4.177 3.211-.044-.053 1.755-1.581 4.023-3.385 2.267-1.804 4.129-3.265 4.177-3.212zM103.67 118.209c-.072.025-.624-1.591-1.547-3.472-.924-1.882-1.857-3.308-1.794-3.352.266.265.495.565.682.89.494.756.941 1.54 1.339 2.35s.742 1.646 1.03 2.501c.143.347.241.711.29 1.083zM99.817 128.879a5.364 5.364 0 0 1-1.204.508 19.68 19.68 0 0 1-6.223 1.025 5.341 5.341 0 0 1-1.305-.092c.43-.06.866-.089 1.3-.087a28.434 28.434 0 0 0 3.124-.305c1.03-.175 2.05-.404 3.056-.686a8.027 8.027 0 0 1 1.252-.363zM89.62 155.799a49.958 49.958 0 0 1-4.178 2.776c-2.345 1.451-4.274 2.626-4.313 2.568a48.883 48.883 0 0 1 4.178-2.781 49.799 49.799 0 0 1 4.313-2.563zM102.848 165.564c-.062.024-1.039-2.51-2.175-5.659-1.137-3.148-2.012-5.721-1.934-5.746.077-.024 1.04 2.51 2.18 5.659 1.141 3.149 1.997 5.722 1.929 5.746zM117.087 145.246a24.847 24.847 0 0 1-1.571-3.096 23.406 23.406 0 0 1-1.339-3.206 24.07 24.07 0 0 1 1.566 3.1 23.508 23.508 0 0 1 1.344 3.202zM170.891 136.468a5.73 5.73 0 0 1-.401 1.088c-.271.662-.648 1.572-1.039 2.587a99.311 99.311 0 0 0-.967 2.617 6.048 6.048 0 0 1-.431 1.078c.041-.386.129-.766.261-1.131.203-.692.513-1.63.909-2.651.397-1.02.798-1.934 1.112-2.573a5.21 5.21 0 0 1 .556-1.015zM125.684 175.769c-.444.029-.89.029-1.334 0a27.065 27.065 0 0 0-6.354.677 9.929 9.929 0 0 1-1.3.28 5.15 5.15 0 0 1 1.257-.454 19.6 19.6 0 0 1 6.401-.682 5.38 5.38 0 0 1 1.33.179zM138.719 176.702c-.067.039-.817-1.32-2.064-2.742-1.248-1.422-2.481-2.365-2.418-2.418.309.143.594.332.846.561a12.954 12.954 0 0 1 1.775 1.698 13.428 13.428 0 0 1 1.45 1.992c.178.283.317.589.411.909zM153.118 172.901a24.772 24.772 0 0 1-2.959 1.934 24.956 24.956 0 0 1-3.085 1.712 24.004 24.004 0 0 1 2.954-1.934 24.616 24.616 0 0 1 3.09-1.712zM168.391 176.025a9.289 9.289 0 0 1-2.146-.102 9.151 9.151 0 0 1-2.123-.348 9.298 9.298 0 0 1 2.147.102c.719.03 1.431.147 2.122.348z"
          fill="#FAFAFA"
        />
        <path
          d="M149.927 53.661a2.147 2.147 0 0 0 3.162 2.36c1.373-.798 1.45-2.756 1.073-4.3-.377-1.542-.991-3.177-.416-4.657.436-1.132 1.48-1.89 2.273-2.805a6.865 6.865 0 0 0 1.571-5.91 5.748 5.748 0 0 0-4.206-4.295c-2.108-.484-4.627.324-6.257-1.093-1.184-1.025-1.353-2.805-2.291-4.058-1.451-1.934-4.323-2.099-6.702-1.635-2.379.465-4.786 1.374-7.17.924-1.992-.377-3.684-1.659-5.575-2.418a10.634 10.634 0 0 0-14.437 9.036 10.64 10.64 0 0 0 1.45 6.315 6.772 6.772 0 0 0 3.477 3.071"
          fill="#263238"
        />
        <path
          d="M141.925 98.607a12.085 12.085 0 0 1-8.801-2.802 12.095 12.095 0 0 1-4.254-8.2c-.328-3.793-.594-6.985-.594-6.985s-9.67-.817-10.468-10.389c-.798-9.571-.677-30.412-.677-30.412v-1.262c10.748-5.543 23.721-3.782 33.797 2.902l.121 1.973 1.929 42.968a12.094 12.094 0 0 1-11.053 12.207z"
          fill="#FFBE9D"
        />
        <path
          d="M121.826 54.773a1.413 1.413 0 0 0 .854-1.339 1.408 1.408 0 0 0-.937-1.282 1.292 1.292 0 0 0-.967.03 1.409 1.409 0 0 0 .083 2.625c.314.114.661.102.967-.034z"
          fill="#263238"
        />
        <path
          d="M118.388 52.771c.16.155 1.049-.633 2.369-.73 1.32-.097 2.321.512 2.456.334.068-.083-.106-.368-.546-.658a3.249 3.249 0 0 0-3.868.319c-.367.353-.488.667-.411.735zM134.276 52.505a1.397 1.397 0 0 0-.554 1.448 1.387 1.387 0 0 0 1.127 1.063 1.395 1.395 0 0 0 1.622-1.42 1.391 1.391 0 0 0-2.195-1.09z"
          fill="#263238"
        />
        <path
          d="M132.438 52.993c.16.155 1.05-.633 2.369-.73 1.32-.096 2.321.513 2.457.334.062-.082-.107-.368-.547-.658a3.25 3.25 0 0 0-3.868.32c-.367.352-.488.667-.411.734zM127.904 64.248c0-.101-.827-.203-2.167-.29-.343 0-.633-.068-.676-.261-.04-.35.021-.704.174-1.02l.855-2.752c1.17-3.923 1.973-7.144 1.784-7.197-.188-.053-1.29 3.07-2.465 6.993-.276.968-.542 1.872-.798 2.767-.195.459-.227.97-.092 1.45a.879.879 0 0 0 .619.484c.194.039.393.05.59.034 1.354-.034 2.176-.111 2.176-.208z"
          fill="#263238"
        />
        <path
          d="M132.299 65.404c1.315-.914-3.641 2.274-6.334 2.332 0 0 1.711 2.355 4.4 1.15 2.794-1.252 1.934-3.481 1.934-3.481z"
          fill="#fff"
        />
        <path
          d="M128.266 80.48s6.082.072 12.232-4.42c0 0-2.466 7.1-12.087 6.906l-.145-2.486z"
          fill="#EB996E"
        />
        <path
          d="M150.923 49.83c.207-.081 7.097-1.034 6.517 7.12-.58 8.154-8.626 4.866-8.626 4.633 0-.232 2.109-11.752 2.109-11.752z"
          fill="#FFBE9D"
        />
        <path
          d="M151.518 58.9c.038 0 .135.11.367.236.328.165.706.2 1.059.097.885-.252 1.707-1.572 1.852-3.037a4.628 4.628 0 0 0-.252-2.06 1.645 1.645 0 0 0-.991-1.171.724.724 0 0 0-.865.333c-.126.218-.083.387-.126.397-.044.01-.169-.15-.077-.483a.906.906 0 0 1 .357-.484c.236-.153.523-.206.798-.15a1.989 1.989 0 0 1 1.393 1.369c.298.731.412 1.525.333 2.311-.169 1.64-1.122 3.115-2.325 3.386a1.5 1.5 0 0 1-1.282-.31c-.241-.237-.271-.42-.241-.435z"
          fill="#EB996E"
        />
        <path
          d="M138.008 47.838c-.212.29-1.648-.43-3.524-.411-1.876.02-3.322.662-3.53.367-.092-.135.174-.527.798-.914a5.468 5.468 0 0 1 5.468.034c.619.397.88.793.788.924zM123.001 48.394c-.078.343-1.103.397-2.307.435-1.204.039-2.233.024-2.33-.314-.097-.339.909-.914 2.296-.967 1.388-.053 2.408.517 2.341.846z"
          fill="#263238"
        />
        <path
          d="M115.101 43.882s5.889 2.583 13.276-1.451c4.835-2.65 10.56-4.068 11.87-3.124 1.311.943 1.76 6.03 6.711 7.332 0 0 0 9.726 3.868 9.237 3.868-.488.88-15.447.88-15.447l-9.099-6.056-10.41-1.572-11.357 1.693-6.334 4.174.595 5.214zM152.112 32.27a7.682 7.682 0 0 0-2.132.483c-.653.33-1.257.75-1.794 1.247-.024 0 .092-.246.373-.55a4.073 4.073 0 0 1 2.901-1.273c.406-.01.657.054.652.092zM147.983 28.598a2.7 2.7 0 0 1 .213.871c.116.714.143 1.44.082 2.162a6.217 6.217 0 0 1-.551 2.094c-.109.283-.274.541-.484.76.084-.284.191-.56.319-.828a7.822 7.822 0 0 0 .484-2.05c.061-.705.061-1.414 0-2.119a4.022 4.022 0 0 1-.063-.89z"
          fill="#263238"
        />
        <path
          d="M147.601 32.758a4.695 4.695 0 0 1-.334.992 5.997 5.997 0 0 1-3.868 3.245 5.342 5.342 0 0 1-2.587.048 6.097 6.097 0 0 1-2.654-1.35 5.703 5.703 0 0 1-1.784-2.804 4.29 4.29 0 0 1-.106-1.814 3.008 3.008 0 0 1 .865-1.688 2.473 2.473 0 0 1 1.828-.735 2.308 2.308 0 0 1 1.76 1.035c.418.595.619 1.315.57 2.04a4.121 4.121 0 0 1-.817 2.037 8.22 8.22 0 0 1-3.675 2.616 10.53 10.53 0 0 1-4.704.634 9.87 9.87 0 0 1-4.656-1.673 5.797 5.797 0 0 1-1.755-1.882 3.744 3.744 0 0 1-.435-1.248 3.53 3.53 0 0 1 .067-1.334 3.31 3.31 0 0 1 .6-1.21c.292-.36.679-.632 1.117-.783a3.093 3.093 0 0 1 2.63.483 4.48 4.48 0 0 1 1.644 2.129c.318.84.416 1.747.285 2.636a5.91 5.91 0 0 1-2.973 4.096 7.445 7.445 0 0 1-4.835.817 8.84 8.84 0 0 1-4.352-1.89 5.266 5.266 0 0 1-1.402-1.843 4.252 4.252 0 0 1-.334-2.235 3.178 3.178 0 0 1 .996-1.934 2.559 2.559 0 0 1 2.002-.682 2.52 2.52 0 0 1 1.707 1.131c.368.575.537 1.255.483 1.935a4.004 4.004 0 0 1-1.861 3.1c-.983.57-2.12.813-3.249.697-1-.09-1.969-.393-2.843-.886-1.644-.914-2.616-2.418-2.718-3.748a3.878 3.878 0 0 1 .803-2.877 2.82 2.82 0 0 1 .571-.532l.227-.14a3.583 3.583 0 0 0-.759.705 3.867 3.867 0 0 0-.759 2.8c.116 1.287 1.073 2.753 2.688 3.638a6.956 6.956 0 0 0 2.785.846 5.236 5.236 0 0 0 3.147-.692 3.812 3.812 0 0 0 1.76-2.955 2.932 2.932 0 0 0-.483-1.794 2.288 2.288 0 0 0-1.542-1.03 2.34 2.34 0 0 0-1.833.634 2.905 2.905 0 0 0-.919 1.818c-.087.72.023 1.451.32 2.114a4.93 4.93 0 0 0 1.344 1.755 8.642 8.642 0 0 0 4.235 1.833 7.252 7.252 0 0 0 4.7-.793 5.659 5.659 0 0 0 2.848-3.922 5.016 5.016 0 0 0-.271-2.51 4.304 4.304 0 0 0-1.552-2.008 2.873 2.873 0 0 0-2.418-.483 2.23 2.23 0 0 0-.996.715c-.26.328-.448.707-.551 1.113a3.325 3.325 0 0 0-.063 1.233c.067.41.205.804.406 1.166a5.533 5.533 0 0 0 1.678 1.799 9.673 9.673 0 0 0 4.54 1.64c1.56.148 3.132-.062 4.598-.615a8.03 8.03 0 0 0 3.578-2.53c.433-.56.703-1.23.779-1.934a2.923 2.923 0 0 0-.523-1.872 2.136 2.136 0 0 0-1.6-.967 2.3 2.3 0 0 0-1.683.677c-.436.425-.723.98-.817 1.582a4.204 4.204 0 0 0 .092 1.736c.291 1.06.89 2.01 1.721 2.728a5.943 5.943 0 0 0 2.578 1.33 5.155 5.155 0 0 0 2.523 0 5.7 5.7 0 0 0 1.934-.9 6 6 0 0 0 1.934-2.249c.115-.232.212-.473.29-.72.044-.189.078-.271.078-.271zM157.082 42.315s0 .029-.062.072c-.063.044-.112.107-.213.18a3.88 3.88 0 0 1-.933.517c-.53.204-1.096.3-1.664.28a3.919 3.919 0 0 1-2.122-.696 4.279 4.279 0 0 1-1.625-2.167 2.728 2.728 0 0 1-.116-1.533 1.26 1.26 0 0 1 .435-.72.88.88 0 0 1 .875-.107c.275.134.493.362.615.643.131.27.204.565.212.866a3.915 3.915 0 0 1-3.331 3.869 3.867 3.867 0 0 1-3.418-1.253 2.07 2.07 0 0 1-.484-1.717 1.448 1.448 0 0 1 1.185-1.214 1.676 1.676 0 0 1 1.513.62c.321.414.492.926.484 1.45a3.175 3.175 0 0 1-1.229 2.419 3.024 3.024 0 0 1-2.122.672 3.311 3.311 0 0 1-1.591-.566 2.986 2.986 0 0 1-.759-.75 1.446 1.446 0 0 1-.184-.324c.269.382.607.71.996.968.464.3.997.474 1.548.508a2.9 2.9 0 0 0 2.001-.673 2.996 2.996 0 0 0 1.117-2.24c.014-.479-.138-.948-.43-1.33a1.458 1.458 0 0 0-1.306-.531 1.223 1.223 0 0 0-.967 1.035 1.854 1.854 0 0 0 .46 1.514 3.613 3.613 0 0 0 3.191 1.16 3.674 3.674 0 0 0 3.123-3.627 1.505 1.505 0 0 0-.677-1.3.636.636 0 0 0-.648.076 1.077 1.077 0 0 0-.357.595 2.51 2.51 0 0 0 .101 1.413c.274.84.81 1.57 1.528 2.084a3.803 3.803 0 0 0 2.026.701c.551.03 1.103-.049 1.624-.232.43-.165.835-.388 1.204-.662zM121.25 139.495l40.653.701.459 27.67-42.079-1.422.967-26.949z"
          fill="#455A64"
        />
        <path
          d="m121.25 139.495 21.042-16.197 19.611 16.898M120.283 166.444c-.053-.048 3.293-3.521 7.461-7.738 4.168-4.218 7.591-7.632 7.639-7.584.048.048-3.288 3.521-7.46 7.763-4.173 4.241-7.591 7.607-7.64 7.559zM162.362 167.866c-.053.044-3.137-3.516-6.889-7.951-3.752-4.435-6.745-8.067-6.692-8.111.053-.044 3.133 3.511 6.885 7.951 3.752 4.44 6.75 8.068 6.696 8.111z"
          fill="#263238"
        />
        <path d="m161.903 140.196-20.81 15.811-19.843-16.512" fill="#263238" />
        <path
          d="m123.262 141.057.227-11.83h35.624l.068 12.952-18.083 13.615-17.836-14.737z"
          fill="#EBEBEB"
        />
        <g
          clip-path="url(#a)"
          stroke="#1C913F"
          stroke-width="1.257"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M148.094 141.224v.578a6.288 6.288 0 0 1-4.502 6.024 6.277 6.277 0 0 1-7.053-2.606 6.285 6.285 0 0 1 7.828-9.163"
          />
          <path d="m148.093 136.774-6.283 6.292-1.885-1.886" />
        </g>
        <path
          d="M120.893 149.458s-.61 6.147.88 6.118c2.601-.043 12.571-2.606 13.272-.686.701 1.92-2.548 3.719-2.548 3.719s3.181.6 1.615 2.259c-1.567 1.659-6.91 9.832-10.347 10.002-4.942.241-11.309-1.427-11.309-1.427l2.601-18.011 5.836-1.974z"
          fill="#FFBE9D"
        />
        <path
          d="M133.705 157.7c-.13.115-.273.216-.425.299-.28.184-.696.426-1.218.711a30.156 30.156 0 0 1-8.752 3.105c-.585.112-1.063.184-1.392.218a2.193 2.193 0 0 1-.518.034c0-.039.721-.164 1.876-.426a38.308 38.308 0 0 0 8.703-3.09c1.064-.523 1.726-.885 1.726-.851zM133.43 162.038c-.099.14-.216.267-.348.377-.339.327-.696.636-1.069.924a18.067 18.067 0 0 1-8.485 3.628c-.465.071-.933.116-1.402.135a2.137 2.137 0 0 1-.518 0c0-.044.73-.097 1.891-.305a20.409 20.409 0 0 0 8.408-3.593c.952-.702 1.494-1.2 1.523-1.166z"
          fill="#EB996E"
        />
        <path
          d="M162.053 149.318s.556 5.132-1.393 5.804c-2.456.866-12.571-2.607-13.277-.692-.706 1.915 2.553 3.724 2.553 3.724s-3.186.6-1.62 2.259c1.567 1.659 6.91 9.828 10.347 9.997 3.39.105 6.782-.128 10.125-.696l-1.417-18.737-5.318-1.659z"
          fill="#FFBE9D"
        />
        <path
          d="M148.728 157.26c0-.034.662.324 1.721.851a38.308 38.308 0 0 0 8.703 3.09c1.16.261 1.885.382 1.876.426a2.196 2.196 0 0 1-.518-.034 23.663 23.663 0 0 1-1.392-.218 30.548 30.548 0 0 1-8.751-3.105 18.782 18.782 0 0 1-1.219-.711 2.004 2.004 0 0 1-.42-.299zM149.284 161.598c.029-.034.561.45 1.489 1.141a20.689 20.689 0 0 0 3.868 2.288 19.214 19.214 0 0 0 4.308 1.325c1.141.208 1.856.256 1.856.3-.16.02-.322.02-.483 0-.461-.016-.922-.06-1.378-.131a16.971 16.971 0 0 1-4.38-1.272 18.112 18.112 0 0 1-3.893-2.374 15.356 15.356 0 0 1-1.039-.914 2.135 2.135 0 0 1-.348-.363z"
          fill="#EB996E"
        />
        <path
          d="M64.197 125.793a17.536 17.536 0 0 1-4.197 0 17.536 17.536 0 0 1 4.197 0zM66.426 119.119a24.68 24.68 0 0 1 0 4.977 24.68 24.68 0 0 1 0-4.977zM68.78 125.633a17.64 17.64 0 0 1 4.197 0 17.536 17.536 0 0 1-4.197 0zM66.571 132.308a24.745 24.745 0 0 1 0-4.982 24.73 24.73 0 0 1 0 4.982zM69.965 129.444c-.058.039-.44-.396-.851-.967a3.387 3.387 0 0 1-.643-1.117c.058-.038.435.392.85.967.284.328.502.707.644 1.117zM69.748 121.876c.053.043-.252.483-.677.996-.426.512-.817.875-.87.831-.054-.043.25-.483.676-.996.426-.512.837-.875.87-.831zM64.956 123.805c-.049.048-.416-.232-.827-.629-.411-.396-.696-.759-.648-.807.048-.049.42.232.827.628.406.397.696.755.648.808zM64.767 127.138c.053.043-.212.483-.604.967-.392.483-.745.865-.803.822.133-.361.34-.69.605-.967.386-.493.75-.866.802-.822zM200.409 102.089a7.869 7.869 0 0 1-2.805 0 7.915 7.915 0 0 1 2.805 0zM201.903 98.268a8.155 8.155 0 0 1 0 2.848 8.107 8.107 0 0 1 0-2.848zM203.488 101.997a7.937 7.937 0 0 1 2.809 0 7.89 7.89 0 0 1-2.809 0zM201.999 105.813a8.158 8.158 0 0 1 0-2.848 8.11 8.11 0 0 1 0 2.848zM204.267 104.178c-.053.044-.319-.188-.595-.517-.275-.329-.454-.633-.401-.677.053-.043.319.184.595.513.275.328.454.638.401.681zM204.16 99.845c.049.048-.145.324-.43.614-.285.29-.556.484-.604.43-.049-.053.14-.319.425-.609s.537-.483.609-.435zM200.916 100.948c-.043.053-.299-.087-.57-.31-.271-.222-.459-.454-.416-.507.044-.054.305.087.575.309.271.222.46.469.411.508zM200.776 102.844c.053.048-.116.314-.377.599-.261.286-.513.484-.561.436-.048-.049.116-.32.377-.605s.527-.464.561-.43zM220.237 98.825l.135.334a2.374 2.374 0 0 0 1.286 1.272l.358.145-.343.14a2.36 2.36 0 0 0-.78.516 2.36 2.36 0 0 0-.516.78l-.097.242-.145-.305a2.365 2.365 0 0 0-1.31-1.19l-.314-.111.411-.198c.515-.25.921-.68 1.141-1.21l.174-.415zM85.326 104.914l.135.329a2.342 2.342 0 0 0 1.281 1.272l.363.145-.348.14a2.364 2.364 0 0 0-1.291 1.296l-.097.242-.145-.304a2.333 2.333 0 0 0-1.31-1.185l-.314-.116.41-.199a2.377 2.377 0 0 0 1.142-1.209l.174-.411zM68.205 151.17l.067.165c.122.289.353.518.644.638l.178.072-.174.068a1.195 1.195 0 0 0-.648.648l-.048.121-.072-.15a1.174 1.174 0 0 0-.653-.595l-.16-.058.208-.096a1.2 1.2 0 0 0 .57-.605l.088-.208zM185.42 84.504l.135.329a2.347 2.347 0 0 0 1.282 1.272l.362.145-.348.14a2.37 2.37 0 0 0-1.291 1.296l-.097.242-.145-.305a2.332 2.332 0 0 0-1.31-1.185l-.314-.116.411-.198a2.36 2.36 0 0 0 1.141-1.21l.174-.41z"
          fill="#455A64"
        />
        <defs>
          <clipPath id="a">
            <path
              fill="#fff"
              transform="translate(134.27 134.26)"
              d="M0 0h15.081v15.085H0z"
            />
          </clipPath>
        </defs>
      </svg>

      <div class="flex flex-col gap-y-[24px] w-full">
        <div class="flex flex-col gap-y-[12px] items-center justify-center">
          <span class="text-[20px] text-[#111] font-EffraM"
            >Découvrir dok Pro</span
          >
          <span class="text-[14px] text-[#767676] font-EffraR text-center"
            >Merci pour votre patience <br />Un conseiller vous contactera dans
            les plus brefs délais</span
          >
        </div>

        <dok-button
          size="lg"
          custom-class="w-full"
          @click.native="$router.push('/')"
          >Acceuil</dok-button
        >
      </div>
    </div>

    <!-- HEADER -->
    <header
      class="
        h-[72px]
        py-[12px]
        px-[24px]
        lg:px-[200px]
        flex flex-row
        items-center
        justify-between
        bg-white
      "
      style="box-shadow: inset 0 -1px 0 0 #f3f3f3"
    >
      <!-- LOGO -->
      <div class="cursor-pointer w-[fit-content]">
        <img
          src="/logos/pro/pro@2x.png"
          class="logo h-[24px]"
          alt="dok.ma"
          @click="$router.push('/')"
        />
      </div>

      <div class="menu-container">
        <a
          :href="menuItem.path"
          class="menu-item"
          v-for="menuItem in menuItems"
          :key="menuItem.label"
        >
          {{ menuItem.label }}
        </a>
      </div>

      <!-- ACTIONS -->
      <button
        class="
          already-member
          h-[48px]
          text-[#297afb]
          bg-transparent
          font-EffraM
          text-[14px]
          lg:text-[16px]
          border-0
          cursor-pointer
        "
        @click="$router.push('/login')"
      >
        Vous êtes déjà inscrit(e)?
      </button>
    </header>

    <!-- MAIN -->
    <div style="background: #f5f9ff" class="pt-[40px]">
      <!-- CONTENT -->
      <div
        class="
          container
          mx-auto
          flex flex-col
          lg:flex-row
          space-y-[32px]
          lg:space-y-0 lg:space-x-[105px]
          justify-center
          overflow-hidden
          pb-10
        "
      >
        <!-- LEFT -->
        <div class="flex flex-col space-y-[32px] w-auto lg:w-[424px]">
          <div class="flex flex-col space-y-[48px]">
            <div class="flex flex-col space-y-[44px]">
              <div class="flex flex-col space-y-[24px]">
                <!-- SVG -->
                <img
                  src="@/assets/svg/aidstwo.svg"
                  class="w-[177px] lg:w-full"
                  alt="Découvrez et testez dok Pro gratuitement et sans engagement"
                />
                <!-- Title -->
                <div class="font-EffraM text-[24px] lg:text-[28px] text-[#000]">
                  Découvrez et testez dok Pro gratuitement et sans engagement
                </div>
              </div>

              <ul class="flex flex-col space-y-[20px]">
                <li
                  class="flex flex-row space-x-[8px]"
                  v-for="(item, index) in list"
                  :key="index"
                >
                  <span
                    class="
                      w-[24px]
                      h-[24px]
                      bg-[#deecff]
                      flex
                      items-center
                      justify-center
                      rounded-full
                    "
                  >
                    <svg
                      width="15"
                      height="16"
                      viewBox="0 0 15 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="m12.5 4.25-6.875 6.876L2.5 8"
                        stroke="#2460D7"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>

                  <span class="font-EffraR text-[16px] text-[#000]">
                    {{ item.name }}
                  </span>
                </li>
              </ul>
            </div>

            <div class="flex flex-col space-y-[10px]">
              <div class="flex flex-row space-x-[16px]">
                <span>
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.5 3.00049H4.5C3.39543 3.00049 2.5 3.89592 2.5 5.00049V15.0005C2.5 16.1051 3.39543 17.0005 4.5 17.0005H20.5C21.6046 17.0005 22.5 16.1051 22.5 15.0005V5.00049C22.5 3.89592 21.6046 3.00049 20.5 3.00049Z"
                      stroke="#297AFB"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.5 21.0005H16.5"
                      stroke="#297AFB"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.5 17.0005V21.0005"
                      stroke="#297AFB"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span>
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.5 18h.01m5.99 4h-12a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2z"
                      stroke="#297AFB"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span>
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.5 2h-10a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z"
                      stroke="#297AFB"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.5 18h.01"
                      stroke="#297AFB"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                </span>
              </div>

              <span class="text-[14px] text-[#767676] font-EffraR">
                La plateforme dok Pro est disponible sur <br />
                ordinateur, tablette et téléphone.
              </span>
            </div>
          </div>

          <div class="flex flex-col space-y-[12px]">
            <div class="flex flex-row space-x-[5px]">
              <span>
                <img
                  src="/art/google-play-line_1.png"
                  srcset="
                    /art/google-play-line_1@2x.png 2x,
                    /art/google-play-line_1@3x.png 3x
                  "
                  alt="android"
                />
              </span>

              <span class="text-[14px] font-EffraR text-[#111]"
                >Disponible pour Android sur le Play Store</span
              >
            </div>
            <div class="flex flex-row space-x-[5px]">
              <span>
                <img
                  src="/art/apple-line_1.png"
                  srcset="
                    /art/apple-line_1@2x.png 2x,
                    /art/apple-line_1@3x.png 3x
                  "
                  alt="ios"
                />
              </span>

              <span class="text-[14px] font-EffraR text-[#111]"
                >Disponible pour IOS sur l'App Store</span
              >
            </div>
          </div>
        </div>

        <!-- RIGHT -->
        <div>
          <div
            class="
              bg-white
              min-w-auto
              lg:min-w-[512px]
              flex flex-col
              space-y-[20px]
              p-[32px]
            "
            style="
              border-radius: 12px;
              box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.05);
            "
          >
            <div class="flex flex-col space-y-[8px]">
              <span>
                <svg
                  width="33"
                  height="32"
                  viewBox="0 0 33 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.167 4.5h3.5v1.667H8V12a5.832 5.832 0 0 0 5.833 5.833A5.832 5.832 0 0 0 19.667 12V6.167H17V4.5h3.5c.46 0 .833.373.833.833V12c0 3.716-2.702 6.8-6.25 7.396l-.416.07V22a5.167 5.167 0 0 0 10 1.826l.167-.441-.43-.192a3.5 3.5 0 1 1 2.391.173l-.275.078-.072.277a6.836 6.836 0 0 1-6.615 5.112A6.833 6.833 0 0 1 13 22v-2.534l-.417-.07A7.502 7.502 0 0 1 6.333 12V5.333c0-.46.374-.833.834-.833zm18.666 13.667a1.834 1.834 0 1 0 .001 3.667 1.834 1.834 0 0 0 0-3.667z"
                    fill="#333638"
                    stroke="#333638"
                  />
                </svg>
              </span>
              <span class="font-EffraM text-[20px] text-[#333638]">
                Êtes-vous un professionnel de santé ? <br />
                Un conseiller va vous recontacter
              </span>
            </div>

            <!-- FORM -->
            <signup-form></signup-form>
            <!-- ACTION -->
          </div>
        </div>
      </div>

      <!-- LINE -->
    </div>

    <!-- VIDEO -->
    <div style="padding: 64px 0px" class="bg-white">
      <!-- CONTENT -->
      <div class="flex flex-col gap-y-[46px] video-s mx-auto">
        <div class="flex flex-row items-center space-x-[8px]">
          <span style="padding-top: 4px">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#eti1xk0fsa)">
                <path
                  d="M11.79 12c2.91 0 5.268-2.302 5.268-5.143 0-2.84-2.358-5.143-5.268-5.143-2.91 0-5.268 2.303-5.268 5.143S8.88 12 11.79 12zm0-9c2.177 0 3.95 1.732 3.95 3.857 0 2.126-1.773 3.857-3.95 3.857-2.177 0-3.95-1.731-3.95-3.857C7.84 4.732 9.612 3 11.79 3zm3.856 10.29c-1.391-.04-1.823.639-3.856.639-2.029 0-2.461-.68-3.852-.64-2.98.085-5.366 2.468-5.366 5.397v3.278c0 .177.148.322.329.322h.658c.181 0 .33-.145.33-.322v-3.278c0-2.182 1.753-3.954 3.95-4.09v3.282c-.95.277-1.646 1.137-1.646 2.158 0 1.241 1.033 2.25 2.305 2.25 1.271 0 2.304-1.009 2.304-2.25 0-1.02-.695-1.88-1.646-2.158v-3.09a8.636 8.636 0 0 0 2.634.422c.897 0 1.778-.148 2.634-.421v2.764c-1.16.301-1.976 1.386-1.976 2.595v1.174c0 .168.07.333.194.454l.424.413a.336.336 0 0 0 .465 0l.465-.454a.317.317 0 0 0 0-.454l-.235-.229v-1.016c0-.78.716-1.398 1.54-1.27.645.105 1.094.7 1.094 1.338v.948l-.235.23a.317.317 0 0 0 0 .453l.465.454a.336.336 0 0 0 .465 0l.424-.413a.638.638 0 0 0 .194-.454v-1.286c0-1.194-.844-2.19-1.976-2.475V14.6c2.198.136 3.951 1.908 3.951 4.09v3.274c0 .177.148.322.33.322h.658c.18 0 .33-.145.33-.322v-3.278c.007-2.93-2.38-5.312-5.355-5.396zm-6.16 6.746a.98.98 0 0 1-.988.964.98.98 0 0 1-.988-.964c0-.53.444-.965.988-.965a.98.98 0 0 1 .987.965z"
                  fill="#297AFB"
                  stroke="#297AFB"
                />
              </g>
              <defs>
                <clipPath id="eti1xk0fsa">
                  <path fill="#fff" d="M0 0h24v24H0z" />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="text-[16px] text-[#297afb] font-EffraM">
            Bénéficiez de nos avantages
          </span>
        </div>
        <!-- VIDEO PREVIEW -->
        <div style="text-align: center">
          <img
            style="max-width: 100%"
            src="/landingPage/group-991.png"
            alt="Bénéficiez de nos avantages"
            srcset="
              /landingPage/group-991@2x.png 2x,
              /landingPage/group-991@3x.png 3x
            "
            class="Group-991"
          />
        </div>
      </div>
    </div>
    <!-- MAIN TWO -->
    <div style="background-color: #f4f8ff">
      <div
        class="flex flex-col gap-y-[46px] video-s mx-auto"
        style="padding: 56px 0px"
      >
        <div class="flex flex-row items-center space-x-[8px]">
          <span style="padding-top: 4px">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g
                clip-path="url(#oo11ntcjva)"
                stroke="#297AFB"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="M19.69 14a6.897 6.897 0 0 0 .31-2V5l-8-3-3.16 1.18M4.73 4.73 4 5v7c0 6 8 10 8 10a20.292 20.292 0 0 0 5.62-4.38M1 1l22 22"
                />
              </g>
              <defs>
                <clipPath id="oo11ntcjva">
                  <path fill="#fff" d="M0 0h24v24H0z" />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="text-[16px] text-[#297afb] font-EffraM">
            La protection de vos données, notre priorité absolue
          </span>
        </div>
        <div class="container-cards">
          <!-- VERSION DESKTOP -->
          <div class="grid w-full grid-cols-1 lg:grid-cols-2 gap-[40px]">
            <div
              v-for="(item, index) in listTwo"
              :key="index"
              class="
                min-h-[232px]
                border border-solid border-[#f1f1f1]
                rounded-[8px]
                p-[40px]
                w-full
                flex flex-col
                space-y-[16px]
                bg-white
              "
            >
              <!-- ICON -->
              <span v-if="item.style === 'one'">
                <img
                  :src="item.svg"
                  class="h-[32px] w-[32px]"
                  :title="item.title"
                />
              </span>

              <!-- TITLE & CONTENT -->
              <div
                class="flex flex-col space-y-[4px]"
                v-if="item.style === 'one'"
              >
                <!-- TITLE -->
                <span
                  class="font-EffraM text-[18px] text-[#111] leading-[28px]"
                >
                  {{ item.title }}
                </span>
                <!-- DESCRIPTION -->
                <span
                  class="font-EffraR text-[16px] text-[#111] leading-[24px]"
                  v-html="item.content"
                ></span>
              </div>

              <!-- STYLE TWO -->
              <template v-if="item.style === 'two'">
                <span class="">
                  <img
                    src="/logos/pro/pro@2x.png"
                    class="logo h-[24px]"
                    alt="dok.ma"
                  />
                </span>

                <div class="flex flex-col space-y-[14px]">
                  <span class="font-EffraM text-[20px] text-[#297afb]"
                    >Découvrez et testez dok Pro gratuitement et sans
                    engagement</span
                  >
                  <dok-button size="md" @click.native="goToTop()"
                    >Je découvre dok Pro</dok-button
                  >
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- OTHER SECTION -->

    <div class="flex flex-col gap-y-[30px] video-s mx-auto">
      <div class="flex flex-row items-center space-x-[8px] pt-10">
        <span>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              clip-path="url(#6fhz16usba)"
              stroke="#297AFB"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
                stroke-width="2.5"
              />
              <path
                d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
                stroke-width="2.5"
              />
              <path d="M12 17h.01" stroke-width="3.917" />
            </g>
            <defs>
              <clipPath id="6fhz16usba">
                <path fill="#fff" d="M0 0h24v24H0z" />
              </clipPath>
            </defs>
          </svg>
        </span>
        <span class="text-[16px] text-[#297afb] font-EffraM"> FAQ </span>
      </div>
      <faq
        v-for="question in faq"
        :key="question.link"
        :link="question.link"
        :question="question.question"
      />
    </div>
    <br />
    <div
      style="text-align: left; border-radius: 12px"
      class="flex flex-col gap-y-[30px] video-s mx-auto"
    >
      <div
        class="flex lg:flex-row flex-col p-[40px]"
        style="gap: 30px; background-color: #f5f9ff"
      >
        <div class="flex flex-col space-x-[24px]">
          <!-- SVG -->
          <img
            src="/landingPage/002-chatting.svg"
            alt="Une tarification transparente, sans frais cachés et sans engagement"
          />
        </div>
        <!-- Title -->
        <div class="flex flex-col">
          <div class="font-EffraM text-[24px] lg:text-[28px] text-[#000]">
            Une tarification transparente, sans frais cachés et sans engagement
          </div>
          <ul class="space-y-[20px]">
            <li
              class="flex flex-row space-x-[8px]"
              v-for="(item, index) in listFooter"
              :key="index"
            >
              <span
                class="
                  w-[24px]
                  h-[24px]
                  bg-[#deecff]
                  flex
                  items-center
                  justify-center
                  rounded-full
                "
              >
                <svg
                  width="15"
                  height="16"
                  viewBox="0 0 15 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m12.5 4.25-6.875 6.876L2.5 8"
                    stroke="#2460D7"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>

              <span class="font-EffraR text-[16px] text-[#000]">
                {{ item.name }}
              </span>
            </li>
          </ul>
          <br />
          <dok-button size="md" @click.native="goToTop()"
            >Je découvre dok Pro</dok-button
          >
        </div>
      </div>
    </div>
    <br />
    <div style="background-color: #f6f6f6">
      <footer-layout
        :down-load-app="false"
        customClassLink="px-0 lg:px-[190px]"
      ></footer-layout>
    </div>

    <!-- OVERFLOW BACKGROUND -->
    <div
      class="bg-black bg-opacity-10 fixed inset-0 z-1"
      v-if="dropdownCity || dropdownSpecialites || isDone"
      @click="
        () => {
          if (dropdownSpecialites) {
            dropdownSpecialites = false;
          }
          if (dropdownCity) {
            dropdownCity = false;
          }
        }
      "
    ></div>
  </main>
</template>

<script>
import algoliasearch from "algoliasearch/lite";
const functionProDok = () =>
  import("@/views/global-components/functionsDokPro");
const footerLayout = () => import("@/views/home/layouts/footer.vue");
import faq from "./faq.vue";
import form from "./form.vue";
export default {
  data() {
    return {
      menuItems: [
        {
          label: "Nos tarifs",
          path: "/pricing",
        },
        {
          label: "Communaute",
          path: "https://community.dok.ma/blog-dok-ma/",
        },
        {
          label: "FAQ",
          path: "/faq",
        },
      ],
      algoliaKeys: algoliasearch(
        "2BJUOM1BDB",
        "7906f008c0346b78f39d051fa293387f"
        // "dfeb264d0cce5f1e2517d1da7bbb2ce1"
      ),
      list: [
        {
          id: 1,
          name: "Augmentez votre confort de travail",
        },
        {
          id: 2,
          name: "Améliorez la prise en charge de vos patients",
        },
        {
          id: 3,
          name: "Gagnez du temps au quotidien",
        },
        {
          id: 4,
          name: "Développez votre activité professionnelle",
        },
      ],
      listFooter: [
        {
          id: 1,
          name: "Aucune installation requise.",
        },
        {
          id: 2,
          name: "Accompagnement personnalisé offert.",
        },
        {
          id: 3,
          name: "Abonnement tout-en-un, licence comprise. ",
        },
        {
          id: 4,
          name: "Résiliation possible à tout moment.",
        },
      ],
      listTwo: [
        {
          style: "one",
          svg: "/landingPage/icon@2x.png",
          title: `Sécurité`,
          content: `Nous disposons de la meilleure équipe d'experts pour garantir la sécurité des données.
Tout le trafic de données qui passe par nos serveurs est analysé et suivi en temps réel.
Toutes les données sont sauvegardées plusieurs fois, dans des lieux sécurisés au Maroc.`,
        },
        {
          style: "one",
          svg: "/landingPage/eye@2x.png",
          title: `Confidentialité`,
          content: `Afin de conserver le secret médical et le secret des données, dok.ma, traitant ces données très sensibles, n’a pas accès aux données de santé des patients. 
dok.ma ne peut, en aucun cas, divulguer une quelconque information, sans l’accord du patient ou anonymisation. 
Que ce soit le nombre de rendez-vous pris, le traitement, ou tout autre type de données.`,
        },
        {
          style: "one",
          svg: "/landingPage/icon@2x.png",
          title: `Protection`,
          content: `L'utilisation de normes strictes en matière de protection et de transfert des données est garantie en permanence. 
Nos systèmes, dotés d’intelligence artificielle, gardent toujours un œil sur toutes les modifications et les écarts sont signalés immédiatement 24/7.`,
        },
        {
          style: "two",
        },
      ],
      mauticError: null,
      specialites: [],
      phone: null,
      cities: [],
      ObjectSpecialities: [],
      dropdownCity: false,
      dropdownSpecialites: false,
      isDone: false,
      form: {
        city: null,
        specialites: [],
      },
      faq: [
        {
          question:
            "Quelles sont les valeurs, la mission et la vision de dok.ma?",
          link: "https://help.dok.ma/fr/articles/5523490-quelles-sont-les-valeurs-la-mission-et-la-vision-de-dok-ma",
        },
        {
          question: "Qu'est ce que dok Pro?",
          link: "https://help.dok.ma/fr/articles/5523169-qu-est-ce-que-dok-pro",
        },
        {
          question: "Quelles fonctionnalités offre dok Pro?",
          link: "https://help.dok.ma/fr/articles/5523259-quelles-fonctionnalites-offre-dok-pro",
        },
      ],
    };
  },
  created() {
    this.onLoadAllSpecialites();
    this.onLoadAllCities();
  },
  mounted() {
    if (this.$route.query.success) {
      this.isDone = true;
    }
    // if (this.$route.query.mauticError) {
    //   this.mauticError = this.$route.query.mauticError.split("<li>");
    // }
  },
  components: { functionProDok, footerLayout, faq, signupForm: form },
  methods: {
    goToTop() {
      window.scrollTo(0, 0);
    },
    choiceSpecilite(spec) {
      if (spec.objectID) {
        if (!this.form.specialites.includes(spec.objectID)) {
          // ADD THIS SPECIALITE
          this.form.specialites.push(spec.objectID);
          this.dropdownSpecialites = false;

          this.$nextTick(() => {
            this.$forceUpdate();
          });
          return;
        }

        this.from.specialites = this.form.specialites.filter((specItem) => {
          return specItem !== spec.objectID;
        });

        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
    },
    choiceCity(city) {
      if (city.objectID) {
        this.form.city = city.objectID;

        this.$nextTick(() => {
          this.dropdownCity = false;
          this.$forceUpdate();
        });

        setTimeout(() => {
          console.log(this.dropdownCity);
        }, 3000);
      }
    },
    async sendSMS() {
      if (!this.phone) {
        this.$vs.notify({
          time: 4000,
          text: "Veuillez remplire le champe",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-triangle",
        });
        return;
      }
      this.$vs.loading();
      this.$store.dispatch("user/SENT_SMS_DOWNLOAD_APP", {
        mobile: this.phone,
        pro: true,
        onData: ({ ok, message }) => {
          this.$vs.notify({
            time: 4000,
            text: message,
            color: ok ? "success" : "danger",
            iconPack: "feather",
            icon: !ok ? "icon-alert-triangle" : "icon-check-circle",
          });
          this.$vs.loading.close();
        },
      });
    },
    async onLoadAllSpecialites() {
      const index = this.algoliaKeys.initIndex("dokma_dev_specialities");
      const data = await index.search("", {
        hitsPerPage: 618,
      });
      this.specialites = data.hits;
    },
    async onLoadAllCities() {
      const index = this.algoliaKeys.initIndex(
        "dokma_dev_cities_principal_first"
      );
      const data = await index.search("", {
        hitsPerPage: 618,
      });
      this.cities = data.hits;
    },
    async submitForm() {
      this.$vs.loading();
      const { ok, message } = await this.$store.dispatch(
        "doctor/VALIDATE_ONBOARDING_FORM",
        { formData: this.form }
      );
      if (ok) {
        this.$vs.loading.close();
        this.isDone = true;
      } else {
        this.$vs.loading.close();
        this.$vs.notify({
          time: 4000,
          text: message,
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-triangle",
        });
      }
    },
  },
};
</script>

<style lang="scss">
.mauticform-name {
  font-weight: bold;
  font-size: 1.5em;
  margin-bottom: 3px;
}
.mauticform-description {
  margin-top: 2px;
  margin-bottom: 10px;
}
.mauticform-error {
  margin-bottom: 10px;
  color: red;
}
.mauticform-message {
  margin-bottom: 10px;
  color: green;
}
.mauticform-row {
  display: block;
  margin-bottom: 20px;
}
.mauticform-label {
  font-size: 1.1em;
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}
.mauticform-row.mauticform-required .mauticform-label:after {
  color: #e32;
  content: " *";
  display: inline;
}
.mauticform-helpmessage {
  display: block;
  font-size: 0.9em;
  margin-bottom: 3px;
}
.mauticform-errormsg {
  display: block;
  color: red;
  margin-top: 2px;
}
.mauticform-selectbox,
.mauticform-input,
.mauticform-textarea {
  width: 100%;
  padding: 0.5em 0.5em;
  border: 1px solid #ccc;
  background: #fff;
  box-shadow: 0px 0px 0px #fff inset;
  border-radius: 4px;
  box-sizing: border-box;
}
.mauticform-checkboxgrp-label {
  font-weight: normal;
}
.mauticform-radiogrp-label {
  font-weight: normal;
}
.mauticform-button-wrapper .mauticform-button.btn-default,
.mauticform-pagebreak-wrapper .mauticform-pagebreak.btn-default {
  color: #5d6c7c;
  background-color: #ffffff;
  border-color: #dddddd;
}
.mauticform-button-wrapper .mauticform-button,
.mauticform-pagebreak-wrapper .mauticform-pagebreak {
  display: inline-block;
  margin-bottom: 0;
  font-weight: 600;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  white-space: nowrap;
  padding: 6px 12px;
  font-size: 13px;
  line-height: 1.3856;
  border-radius: 3px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.mauticform-button-wrapper .mauticform-button.btn-default[disabled],
.mauticform-pagebreak-wrapper .mauticform-pagebreak.btn-default[disabled] {
  background-color: #ffffff;
  border-color: #dddddd;
  opacity: 0.75;
  cursor: not-allowed;
}
.mauticform-pagebreak-wrapper .mauticform-button-wrapper {
  display: inline;
}
.mauticform-field-hidden {
  display: none;
}
.footer {
  @apply h-auto lg:h-[447px] py-[32px] lg:py-[40px] px-[16px] lg:px-[200px];
  background-color: #f5f9ff;

  @media (min-width: 992px) {
    background-image: url("/mobile.png");
    background-repeat: no-repeat;
    background-size: 60%;
    background-position: calc(100% - 5%) calc(100% - -2%);
  }

  @media (max-width: 991px) {
  }
}

.content-parent {
  @apply bg-red-500;
  width: calc(100vw - 435px);
  margin: 0 auto;
}

.container-cards {
  @apply flex flex-row space-x-[105px] justify-center;
  margin: 0 auto;
}

.services {
  @apply flex flex-col lg:flex-row space-y-5 lg:space-y-0 space-x-0 lg:space-x-[105px] justify-center;
  width: calc(100vw - 500px);

  @media (max-width: 1368px) {
    width: calc(100vw - 30px);
  }

  @media (max-width: 1120px) {
    width: calc(100vw - 30px);
  }

  @media (max-width: 762px) {
    width: calc(100vw - 30px);
  }
  margin: 0 auto;
}

.video-s {
  width: calc(100vw - 500px);

  @media (max-width: 1368px) {
    width: calc(100vw - 30px);
  }

  @media (max-width: 1120px) {
    width: calc(100vw - 30px);
  }

  @media (max-width: 762px) {
    width: calc(100vw - 30px);
  }
}
.card-x {
  width: calc(100vw - 750px);

  @media (max-width: 1368px) {
    width: calc(100vw - 500px);
  }

  @media (max-width: 1120px) {
    width: calc(100vw - 400px);
  }

  @media (max-width: 762px) {
    width: calc(100vw - 30px);
  }
}
.min-h-screen {
  background-color: white;
}
.logo-image {
  height: 24px;
}

.menu-container {
  width: 428px;
  height: 24px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 32px;
}

.menu-item {
  font-size: 16px;
  line-height: 1.25;
  color: #5d6267;
  text-decoration: none;
}

.menu-item:hover {
  color: #44484b;
}

.navbar {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  padding: 12px;
  box-shadow: inset 0 -1px 0 0 #f3f3f3;
  background-color: #fff;
  align-items: baseline;
}

@media (max-width: 800px) {
  .menu-container,
  .already-member {
    display: none;
  }
}
</style>
